import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { ILocationNote } from '~/types/note/models'

export const {
  getNoteListData: getLocationNoteListData,
  getNoteDataById: getLocationNoteDataById,
  getNoteListDataByParentId: getLocationNoteListDataByLocationId,
} = makeNoteMockData<ILocationNote>({
  entityName: 'location',
  storageKeyPrefix: 'location',
})
